import React, { Component } from 'react'
import Card from '../card'
import CardContainer from '../card-container/cardContainer'
import CardHolder from '../../card-holder/cardHolder'
import CardTitle from '../../card-title/card-title'
import { getCall, baseUrl } from '../../../../../helpers/api'

class PlantCardsExample extends Component {

    constructor(props) {
        super(props)
        this.state = {
            types: []
        }
        this.calculateHref = this.calculateHref.bind(this)
    }

    async componentDidMount() {
        const types = await getCall("/plantType/getall")
        const search = await getCall("/search/kır")
        console.log(search)
        await this.setState({ types: types.data })
    }

    calculateHref(typeName){
        if(typeName === "Çiçek")
            return "color"
        else if(typeName === "Ağaç")
            return "agac"
        else
            return "agac"
    }

    render() {
        return (
            <CardContainer>
                <CardTitle title="Bitkinizi Seçin" />
                <CardHolder>
                    {this.state.types.map((t, index) => (
                        <Card key={index} history={this.props.history} image={baseUrl + t.image} typeText={t.typeName} href={this.calculateHref(t.typeName)}/>
                    ))}

                </CardHolder>
            </CardContainer>
        )
    }
}

export default PlantCardsExample
